import { client } from "@/utils/client";

export function getDevices() {
    return client({
        url: "/console/devices/",
        method: "get",
    })
}

export function deleteDevice(query) {
    return client({
        url: "/console/devices" + query,
        method: "delete"
    })
}




//////////////////
// WEBPACK FOOTER
// ./src/api/device.js
// module id = null
// module chunks = 